import React, { useEffect, useState } from "react";
import "./invitationVolunteerOfAssociation.scss";

import { useNavigate, useParams } from "react-router-dom";

import Header from "./components/header/Header";
import CardAssociation from "../../components/cardAssociation/CardAssociation";
import Footer from "./components/footer/Footer";

import { Button, Col, Image, Row, Stack } from "react-bootstrap";
import { t } from "i18next";
import { isEmpty } from "../../utils/validation";
import {
  getInfoAssociationWS,
  postViewAndActionPageInvitationWS,
} from "./api/invitationVolunteerOfAssociationApi";
import { gestioneSnackbar } from "../../utils/common";

const InvitationVolunteerOfAssociation = () => {
  const navigate = useNavigate();
  const { id_association } = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    getInfoAssociationWS(id_association)
      .then((res) => {
        setData(res);
      })
      .catch((err) => console.log(err));

    postViewAndActionPageInvitationWS({
      id_association,
      cta_registration: false,
      cta_view_association: false,
    });
  }, [id_association]);

  console.log(data);

  return (
    <>
      <Header />
      <div className="container-responsive p-2">
        <Stack gap={5}>
          <Row className="g-2">
            <Col sm={12} md={12} lg={6}>
              <Image
                className="w-100 h-100 rounded"
                src="/invitation_volunteer.png"
                rounded={false}
              />
            </Col>
            <Col
              sm={12}
              md={12}
              lg={6}
              className="d-flex justify-content-center align-items-center"
            >
              <Stack gap={5}>
                <Stack gap={3} className="d-flex align-items-center">
                  <h2 className="title-invitation">
                    {t("invitation_volunteer_of_association.title")}
                  </h2>
                  <p className="w-75">
                    {t("invitation_volunteer_of_association.subtitle")}
                  </p>
                  <Button
                    variant="success"
                    className="w-50"
                    size="md"
                    onClick={() => {
                      if (isEmpty(localStorage.getItem("accessToken")))
                        postViewAndActionPageInvitationWS({
                          id_association,
                          cta_registration: true,
                          cta_view_association: false,
                        })
                          .then(() =>
                            navigate(
                              "/registration?id_association=" + id_association
                            )
                          )
                          .catch(() =>
                            gestioneSnackbar(true, t("error.500"), "error")
                          );
                      else
                        postViewAndActionPageInvitationWS({
                          id_association,
                          cta_registration: false,
                          cta_view_association: true,
                        })
                          .then(() =>
                            navigate("/association/" + id_association)
                          )
                          .catch(() =>
                            gestioneSnackbar(true, t("error.500"), "error")
                          );
                    }}
                  >
                    {isEmpty(localStorage.getItem("accessToken"))
                      ? t("invitation_volunteer_of_association.signup_now")
                      : t(
                          "invitation_volunteer_of_association.view_association"
                        )}
                  </Button>
                </Stack>

                {!isEmpty(data) ? (
                  <Stack className="w-75 mx-auto">
                    <span className="invited-by text-start">
                      {t("invitation_volunteer_of_association.invited_by")}
                    </span>
                    <CardAssociation
                      disabledSelection={true}
                      name={data.name}
                      image={
                        data.image
                          ? "data:" + data.image_type + ";base64," + data.image
                          : "/no_img.png"
                      }
                      idAssociation={data.id}
                      link={false}
                      setSelected={false}
                      height={110}
                    />
                  </Stack>
                ) : null}
              </Stack>
            </Col>
          </Row>
        </Stack>
      </div>
      <Footer />
    </>
  );
};

export default InvitationVolunteerOfAssociation;
